export default __webpack_public_path__ + "static/media/black_common_king.a8459b2f.png";